<template>
  <checkout-steps :step="checkout.step" @step="onStep"/>
  <div class="container">
    <div class="checkout flex">
      <checkout-total-top v-if="checkout.step === 1" :totals="totals" :step="checkout.step" @next="onNextStep"/>
      <checkout-cart v-if="checkout.step === 1" :cart-data="cartData"/>
      <div v-if="checkout.step === 2" class="checkout-personal">
        <checkout-personal :checkout="checkout"/>
        <checkout-delivery :checkout="checkout" @change="onShippingMethodCodeUpdated" @pickup="changePickupPoint" />
        <checkout-payments :checkout="checkout" :payments="filteredPayments" @codeChanged="onPaymentMethodCodeUpdated"
                           @onDataChanged="saveAndRecalc"/>
      </div>
      <checkout-total :totals="totals" :step="checkout.step" :shipping="checkout.shipping_method_code" :enabled="buttonEnabled" @next="onNextStep" />
    </div>
  </div>
</template>

<script>
import CheckoutSteps from "@/components/checkout/checkout-steps";
import CheckoutTotal from "@/components/checkout/checkout-total";
import CheckoutTotalTop from "@/components/checkout/checkout-total-top";
import CheckoutCart from "@/components/checkout/checkout-cart";
import CheckoutPersonal from "@/components/checkout/checkout-personal";
import CheckoutDelivery from "@/components/checkout/checkout-delivery";
import CheckoutPayments from "@/components/checkout/payments/payments";

export default {
  name: "Checkout",
  components: {
    CheckoutPayments,
    CheckoutSteps,
    CheckoutTotal,
    CheckoutTotalTop,
    CheckoutCart,
    CheckoutPersonal,
    CheckoutDelivery,
  },
  props: {},
  data() {
    return {
      cartData: {
        products: []
      },
      payments: [],
      totals: [],
      checkout: {},
      checkoutErrors: [],
    }
  },
  computed: {
    filteredPayments(){
      if(this.checkout.shipping_method_code === 'ups'){
        return this.payments.filter(i => i.code === 'zcredit_card');
      }
      return this.payments.filter(i => i.code !== 'card');
    },
    buttonEnabled() {
      if(this.checkout.step === 2) {
        return !!this.checkout?.personal_info?.first_name
          && !!this.checkout?.personal_info?.last_name
          && !!this.checkout?.personal_info?.email
          && !!this.checkout?.personal_info?.phone;
      }
      return true;
    },
  },
  beforeMount() {
    this.getState()
    this.getTotals()
    this.getPayments()
  },
  mounted() {
    this.loadCartData();
    window.addEventListener('cartUpdated', this.loadCartData)
    window.scrollTo(0, 0);
  },
  beforeUnmount() {
    window.removeEventListener('cartUpdated', this.loadCartData)
  },
  provide() {
    return {
      getErrors: () => {
        const err = {};
        for (const k in this.checkoutErrors) {
          err[k] = this.checkoutErrors[k][0]
        }
        return err
      }
    }
  },
  methods: {
    saveAndRecalc() {
      this.saveState()
      .then(() => {
        Cart.getItems();
      })
    },
    onStep(step) {
      this.checkout.step = step
      this.saveState()
    },
    onPaymentMethodCodeUpdated(new_code) {
      this.checkout.payment_method_data = null
      this.checkout.payment_method_code = new_code
      this.saveAndRecalc()
    },
    onShippingMethodCodeUpdated(new_code) {
      if(new_code === 'ups'){
        this.checkout.payment_method_code = 'zcredit_card'
        this.checkout.pickup_point_id = null;
      }
      this.checkout.shipping_method_data = null
      this.saveAndRecalc()
    },
    loadCartData() {
      this.cartData = window.cartData

      if(this.cartData.products.length === 0){
        window.location.href = '/'
      }

      this.getTotals();
    },
    onNextStep() {
      const that = this;
      switch (this.checkout.step) {
        case 1:
          that.checkout.step++;
          this.saveState()
            .then(() => {
            });
          break;
        case 2:
          this.submitOrder();
          break;
      }
    },
    getState() {
      const that = this;
      axios.get(route('client.checkout.get-state'))
        .then((resp) => {
          that.checkout = {
            ...resp.data.checkout
          };
        })
    },
    getPayments() {
      const that = this;
      axios.get(route('client.checkout.payments'))
        .then((resp) => {
          that.payments = [
            ...resp.data
          ]
        })
    },
    getTotals() {
      const that = this;
      axios.get(route('client.checkout.totals'))
        .then((resp) => {
          that.totals = {
            ...resp.data.totals
          };
        })
    },
    async saveState() {
      const that = this;
      //Todo crutch remove
      // this.checkout['payment_method_name'] = 'מזומן שטרות';
      // this.checkout['payment_method_code'] = 'cod';
      return axios.post(route('client.checkout.save-state'), {checkout: this.checkout});
    },
    changePickupPoint(pickup_point_id) {
      this.checkout.pickup_point_id = pickup_point_id;
      this.saveAndRecalc()
    },
    submitOrder() {
      this.saveState()
        .then(() => {
          axios.post(route('client.checkout.submit'), this.checkout)
            .then((resp) => {
              //console.log(JSON.stringify(resp))
              // if (!resp.data.success) {
              //   return;
              // }
              window.order_totals = null;
              window.order_id = null;
              let productData = [];
              window.cartData.products.forEach((item) => {
                productData.push({
                  item_name: item.name,
                  item_id: item.article,
                  price: item.price,
                  item_brand: "Babolat",
                  item_category: item.category,
                  quantity: item.quantity
                })
              })
              if(resp.data.location.indexOf('success') !== -1) {
                window.order_totals = Object.values(this.totals).find(c => c.code === 'total').value;
                window.order_id = resp.data.order_id;
                dataLayer.push({ ecommerce: null });
                dataLayer.push({
                  event: "purchase",
                  ecommerce: {
                    transaction_id: resp.data.order_id,
                    affiliation: "babolat.co.il",
                    value: Object.values(this.totals).find(c => c.code === 'total').value,
                    shipping: Object.values(this.totals).find(c => c.code === 'shipping').value,
                    currency: "ILS",
                    items: productData,
                  }
                });
                /*window.uetq = window.uetq || [];
                window.uetq.push('event', '', {
                  "revenue_value": this.totals.find(c => c.code === 'total').value,
                  "currency": "ILS"
                });*/
              }
              window.location.href = resp.data.location
            })
            .catch((error) => {
              console.log(error)
              this.checkoutErrors = error.response?.data?.errors??[];
              if(!this.checkoutErrors.length) {
                return;
              }
              document.querySelector('.errors-checkout-modal').classList.add('errors-checkout-modal-active');
              if(typeof error.response.data.errors['personal_info.password'][0] !== 'undefined') {
                if(error.response.data.errors['personal_info.password'][0] === 'The personal info.password field is required.' || error.response.data.errors['personal_info.password'][0] === 'The personal info.password must be at least 5 characters.') {
                  document.getElementsByClassName('text-checkout-error')[0].innerHTML = 'אורך הסיסמה חייב להחיל לפחות 6 תווים';
                }
                if(error.response.data.errors['personal_info.password'][0] === 'The personal info.password confirmation does not match.') {
                  document.getElementsByClassName('text-checkout-error')[0].innerHTML = 'הסיסמאות לא תואמות';
                }
              }
              console.log(error.response.data.errors['personal_info.password']);
              setTimeout(function () {
                document.querySelector('.errors-checkout-modal').classList.remove('errors-checkout-modal-active')
              }, 3000);
            })
        })
    }
  }
}
</script>

<style scoped>

</style>
